import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { DOCUMENT_TYPE, updateActionStatus } from "../../../../constants";
import PropTypes from "prop-types";
import { projectServices } from "../../../../services/api";
import messages from "../../../../services/api/messages";
import PrimaryBtn from "../../../UI/Button/PrimaryBtn";
import Button from "../../../UI/Button";

const UploadDocumentForm = ({
  caseInfoId,
  documentType,
  onCloseModal,
  text,
  caseId,
  customerId,
  fileInfo,
  setIsOpenUploadFileModal,
}) => {
  const [fileNames, setFileNames] = useState(fileInfo.map(file => {
    return file.fileName ?? file.fileUrl.split("/").pop()
  }));
  const [files, setFiles] = useState([]);
  const inputRef = useRef();
  const inputId = uuidv4();

  const handleChangeFile = (event) => {
    const newFiles = Array.from(event.target.files);

    let cFileNames = fileNames;
    let cFiles = files;
    newFiles.forEach((file) => {
      if (file) {
        cFiles.push(file);
        cFileNames.push(file.name);
      }
    });

    setFiles(cFiles.slice(0, 10));
    setFileNames(cFileNames.slice(0, 10));
  };

  const handleUpload = () => {
    projectServices
      .uploadDocument(caseInfoId, documentType, files)
      .then((res) => {
        if (res) {
          toast.success(messages.update(true));
          onCloseModal();
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((err) => {
        toast.error(messages.callApiFail);
      });
  };

  return (
    <div className="flex flex-col gap-4 md:min-w-[400px] overflow-y-auto"
         style={{maxHeight: 'max(500px, calc(100vh - 515px))'}}>
      <div className="flex gap-8">
        <p className="min-w-[42px]">案件ID</p>
        <p>{caseId}</p>
      </div>
      <div className="flex gap-8">
        <p className="min-w-[42px]">顧客ID</p>
        <p className="min-w-[42px] max-w-[500px] break-all pr-4">{customerId}</p>
      </div>
      <div className="flex items-center gap-8">
        <p className="min-w-[42px]">{text || "報告書"}</p>
        <div className="max-w-[500px] pr-4">
          <div
            className="relative cursor-pointer"
            onClick={() => {
              inputRef.current && inputRef.current.click();
            }}
          >
            <div className="p-2.5 text-sm border rounded-xl border-[#B3B3B3] !outline-none bg-[#ebebeb]">
              <p className="text-xs">
                ファイルを選択
              </p>
            </div>
            <input
              ref={inputRef}
              id={inputId}
              name={inputId}
              type="file"
              onChange={handleChangeFile}
              className="hidden"
              multiple
            />
          </div>
        </div>
      </div>

      <div className="flex gap-8">
        <p className="min-w-[42px]"></p>
        <p className="text-xs text-gray-600">※ファイルは10個までアップロードしてください。</p>
      </div>

      {fileNames.length > 0 && (
        <div className="flex gap-8">
          <p className="min-w-[42px]"></p>
          <p className="text-xs max-w-[500px] break-all pr-4">
            {fileNames.map(fileName => {
              return (
                <p>{fileName}</p>
              )
            })}
          </p>
        </div>
      )}
      <div className="flex justify-end gap-2 mt-4">
        <Button
          onClick={handleUpload}
          disabled={files.length === 0}
          type={files.length === 0 ? "disabled" : "primary"}
        >{updateActionStatus.confirmation}</Button>
        <PrimaryBtn
          text={updateActionStatus.close}
          onClick={() => setIsOpenUploadFileModal(false)}
        />
      </div>
    </div>
  );
};

UploadDocumentForm.propTypes = {
  caseInfoId: PropTypes.string.isRequired,
  documentType: PropTypes.oneOf(Object.values(DOCUMENT_TYPE))
    .isRequired,
  onCloseModal: PropTypes.func.isRequired,
  text: PropTypes.string,
};

export default UploadDocumentForm;
